import React from 'react'

// item
import CategoryItem from './CategoryItem'
import LeftBarLoadingSkeleton from './LeftBarLoadingSkeleton'

export default function CategoriesLeftBar(props) {
    const {
        categoriesLoading,
        categoriesLoadingIndicator,
        
        categories,
        selectedCategory,
        handleCategoryNameClick,

        leftBarExpandedCategories,
        handleExpandCategory
    } = props

    return (
        <div className="category-left-bar">
            <div className="inner">
                {/* head */}
                <p className="cl-head st-fw-600 text-uppercase mb-2">All Categories</p>
                {
                    /* loading */
                    categoriesLoading && (
                        <React.Fragment>
                            {
                                categoriesLoadingIndicator?.length ? categoriesLoadingIndicator.map(item => (
                                    <React.Fragment key={item}>
                                        <LeftBarLoadingSkeleton />
                                    </React.Fragment>
                                )) : null
                            }
                        </React.Fragment>
                    )
                }
                {
                    categories?.length ? categories.map((item, index) => {
                        return (
                            <React.Fragment key={item.category_id}>
                                <CategoryItem
                                    categoryItem={item}
                                    categoryItemIndex={index}

                                    selectedCategory={selectedCategory}
                                    handleCategoryNameClick={(ev, id) => handleCategoryNameClick(ev, id)}

                                    leftBarExpandedCategories={leftBarExpandedCategories}
                                    handleExpandCategory={(ev, id) => handleExpandCategory(ev, id)}
                                />
                            </React.Fragment>
                        )
                    }) : (
                        <p className="no-data-found">No data found</p>
                    )
                }
            </div>
        </div>
    )
}
